import {
  CollectionActions,
  CollectionStateSlice,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { CommentsCollection } from '../comments/comments.types';
import { FeedPostsCollection } from '../feed-posts/feed-posts.types';
import {
  transformReaction,
  transformReactionTypeCount,
} from './reactions-type-count.transformers';
import { ReactionsTypeCountCollection } from './reactions-type-count.types';

export function reactionsTypeCountReducer(
  state: CollectionStateSlice<ReactionsTypeCountCollection> = {},
  action: CollectionActions<
    CommentsCollection | ReactionsTypeCountCollection | FeedPostsCollection
  >,
) {
  switch (action.type) {
    case 'API_PUSH': {
      // The component must provide a ReactionTypeCount object in order to
      // increase/decrease its count and negate the hasUserReacted property.
      if (action.payload.type === 'reactionsTypeCount') {
        const { document, ref } = action.payload;
        return mergeWebsocketDocuments<ReactionsTypeCountCollection>(
          state,
          transformIntoDocuments([document], transformReactionTypeCount),
          ref,
        );
      }
      return state;
    }

    case 'API_PUSH_ERROR': {
      // If there is an API error it reverts API_PUSH effect.
      if (action.payload.type === 'reactionsTypeCount') {
        const { document, ref } = action.payload;
        return mergeWebsocketDocuments<ReactionsTypeCountCollection>(
          state,
          transformIntoDocuments([document], transformReactionTypeCount),
          ref,
        );
      }
      return state;
    }

    case 'API_FETCH_SUCCESS': {
      // Post and comment reactions are obtained and merged in
      // from their primary resource using a projection against their API.
      if (
        action.payload.type === 'feedPosts' ||
        action.payload.type === 'comments'
      ) {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<ReactionsTypeCountCollection>(
          state,
          transformIntoDocuments(result.reactions_count, transformReaction),
          {
            path: {
              collection: 'reactionsTypeCount',
              authUid: ref.path.authUid,
            },
          },
        );
      }
      return state;
    }

    case 'WS_MESSAGE': {
      // TODO (T229425)
      //  Receive the ReactionApi object from the WS
      //  whenever an other user has reactod on the context object.
      return state;
    }

    default:
      return state;
  }
}
